


































































































































































import { Component, Vue } from 'vue-property-decorator'
import FuncaoDescricao from '@/factories/ProfissionalExecutanteFuncaoDescricao'

@Component({
  props: {
    relatorio: {},
    statusRelatorio: {
      type: String,
    },
  },
})

export default class ComponentRelatorioStatus extends Vue {
  mounted() {}

  hideElement(status, previsto, recebido) {
    // @ts-ignore
    if (!this.statusRelatorio) {
      if (previsto !== 0) {
        return true
      }
      return false
    }
    // @ts-ignore
    if (this.statusRelatorio === this.getSplitStatus(status)) {
      return true
    }

    return false
  }

  getSplitStatus(status) {
    const text = status.split(' ').join('').toLowerCase().replace(/ã/, 'a')

    return text
  }

  FuncaoDescricao(grau) {
    return FuncaoDescricao.funcao(grau)
  }
}

